import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more.js';
import SolidGauge from 'highcharts/modules/solid-gauge.js';
import * as lib from '@/util/lib.js';
Highcharts.setOptions({
	colors: stage.color.list,
	tooltip: {
		shared: true,
		headerFormat: '',
		backgroundColor: '#7a7a7a',
		borderColor: '#7a7a7a',
		style: {color: '#fff', padding: '1em'},
		borderRadius: (function () {
			return parseInt($('html').css('font-size')) / 2;
		}())
	}
});

HighchartsMore(Highcharts);
SolidGauge(Highcharts);
import { getLanguageStr } from '@/util/language.js';
import {timeFormat, getTypeText} from '@/util/lib.js';

const lineStyle = ['Solid', 'Dash', 'ShortDot', 'ShortDashDot', 'Dot', 'LongDash', 'LongDashDot', 'ShortDash']; // Solid,ShortDash,ShortDot,ShortDashDot,ShortDashDotDot,Dot,Dash,LongDash,DashDot,LongDashDot,LongDashDotDot,全局的线性列表，供图表使用

function getTooltip (type, otherData, dom) { // 统一处理提示框	//dom 获取当前图表legend
	const def = {
		// crosshairs:{width:1,color:(option.color&&data.length<=1)?	option.color:"#ccc"},
		// xDateFormat: '%Y/%m/%d %H:%M:%S',
		/*
		pointFormat:'{series.name} produced <b>{point.y:,.0f}</b><br/>warheads in {point.x}',
		*/
	};
	let ex = {
		// pointFormat:null,
		// formatter:null
	};
	switch (type) {
	case 'column':
		ex.formatter = function () {
			var dateFeature = String(this.x).split('-').length;
			var timeOffset = '';
			if (otherData.timeOffset != undefined) {
				var operator = (otherData.timeOffset >= 0) ? '+' : '-';
				var timeOffset_h = Math.floor(Math.abs(otherData.timeOffset) / 60);
				var timeOffset_m = Math.abs(otherData.timeOffset) - timeOffset_h * 60;
				var timeOffset = ' (UTC' + operator + fill2str(timeOffset_h) + ':' + fill2str(timeOffset_m) + ')';
			}
			var head = (dateFeature > 2) ? this.x.split(' ').shift().replace(/-/g, '/') + timeOffset : this.x + timeOffset;
			// if (otherData.timeType == "month") { //月档位给标题的数字追加“月”字
			// 	head += getLanguageStr("cmd93", "日");
			// }else if(otherData.timeType == "all") head += getLanguageStr("cmd96", "年");
			// else head += getLanguageStr("cmd95", "月");
			var body = '<br>';
			let hoverIndex;
			if (otherData.timeType == 'all') {
				let points = this.points;
				hoverIndex = otherData.xCategories.indexOf(this.x);
				// this.points.map(v => {
				// 	// trace(v)
				// 	var timeOffsetSingle = ''
				// 	var unit = v.series.userOptions.unit || ''
				// 	let val = v.y
				// 	val = $.isNumeric(val) ? Math.round(val * 100) / 100 : val
				// 	val = val == null ? '--' : getTypeText(val, this.dataType)
				// 	body += '<span style="color:' + v.color + ';font-size:1.5em;">\u25CF</span> ' + v.series.name + timeOffsetSingle + '：' + val + unit + '<br>'
				// })
				$.each(otherData.data, function (index) {
					if ($(dom).find('.highcharts-series-' + this.legendSelectIndex + '.highcharts-legend-item-hidden').length == 0) {	// 当前参数legend激活才显示浮窗中当前参数数据
						let timeOffsetSingle = '';
						let unit = this.unit ? ' ' + this.unit : '';
						let val = this.data[hoverIndex];
						val = $.isNumeric(val) ? lib.floatFix(val, 2) : val;
						val = val == null ? '--' : getTypeText(val, this.dataType);
						let color = stage.color.list[index];
						body += '<span style="color:' + color + ';font-size:1.5em;">\u25CF</span> ' + this.name + timeOffsetSingle + '：' + val + unit + '<br>';
					}
				});
			} else {
				hoverIndex = this.x - 1;
				let val = this.y;
				$.each(otherData.data, function (index) {
					if ($(dom).find('.highcharts-series-' + this.legendSelectIndex + '.highcharts-legend-item-hidden').length == 0) {	// 当前参数legend激活才显示浮窗中当前参数数据
						let timeOffsetSingle = '';
						let unit = this.unit ? ' ' + this.unit : '';
						let color = $.type(this.color) == 'string' ? this.color : stage.color.list[index];
						switch (this.type) {
						case 'areaspline':
							if (otherData.tooltipGetValue) {
								val = otherData.tooltipGetValue(val);
							}
							body += '<span style="color:' + color + ';font-size:1.5em;">\u25CF</span> ' + this.name + timeOffsetSingle + '：' + val + unit + '<br>';
							break;
						default:
							// if (this.series.userOptions.timeOffset != undefined) {
							// 	var thisTimeOffset = this.series.userOptions.timeOffset;
							// 	var operator = (thisTimeOffset >= 0) ? "+" : "-";
							// 	var timeOffset_h = Math.floor(Math.abs(thisTimeOffset) / 60);
							// 	var timeOffset_m = Math.abs(thisTimeOffset) - timeOffset_h * 60;
							// 	var timeOffsetSingle = " (UTC" + operator + fill2str(timeOffset_h) + ":" + fill2str(timeOffset_m) + ") ";
							// }
							val = this.data[hoverIndex];
							val = $.isNumeric(val) ? lib.floatFix(val, 2) : val;
							val = val == null ? '--' : getTypeText(val, this.dataType);
							body += '<span style="color:' + color + ';font-size:1.5em;">\u25CF</span> ' + this.name + timeOffsetSingle + '：' + val + unit + '<br>';
							break;
						}
					}
				});
			}
			if (otherData.dataHover) {
				otherData.dataHover({
					dataX: this.x,
					dataY: this.y
				// customData:option.customData["t"+this.x]
				});
			}
			return head + body;
		};
		break;
	case 'ring':
		ex.pointFormat = '{point.name}<br><b>{point.y}</b>'; // {point.name}:
		break;
	case 'time':
		ex.formatter = function () {
			let date = new Date(this.x);
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDay();
			let hour = date.getHours();
			let minute = date.getMinutes();
			return year + '/' + (month < 10 ? '0' : '') + month + '/' + (day < 10 ? '0' : '') + day + ' ' + (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
		};
		break;
	case 'alarmTime':// 报警图表

		ex.formatter = function () {
			let times = '';
			if (window.fomateTimeLine[this.x]) {
				times = window.fomateTimeLine[this.x];
			} else {
				times = this.x;
			}
			// let date = new Date(this.x);
			// let hour = date.getHours();
			// let minute = date.getMinutes();
			// return (10 > hour ? '0' : '') + hour + ':' + (10 > minute ? '0' : '') + minute;
			// console.log(this.x)
			// timeFormat(this.x / 1000, 'utc', '%H:%M')
			// Highcharts.dateFormat('%Y/%m/%d %H:%M:%S', this.x)
			// console.log(this)
			return Highcharts.dateFormat('%H:%M:%S', times);
		};
		break;

	case '':
		break;
	}
	return $.extend(true, {}, def, ex);
}

export function drawPie (dom, dataArray2x, optionNew) { // 绘制圆环
	// dataArray2x:[
	// ["name",number],....
	// ]
	var option = {
		colors: $.extend(true, [], stage.color.list),
		hover: true,
		lineW: 8,
		space: []
	};
	if (option.hover == false) option.space = [10, 10, 10, 10];
	else option.space = [0, 0, 0, 0];
	$.extend(option, optionNew);
	/*
	if(typeof(colors)=="number")	lineW=colors;
	if(typeof(colors)!=="object"||typeof(colors)=="number"){
		colors=["#fdc559","#ff595f","#15d0bb"];
	}
	if(lineW==undefined)	lineW=8;
	*/

	// 处理0数据的呈现
	var count = 0;
	$(dataArray2x).each(function () {
		count += this[1];
	});
	if (count == 0) {
		var newData = new Array(); // 重新创建数据，防止改动原始数据导致后续程序使用数据有问题
		$(dataArray2x).each(function (index) {
			newData.push(this.concat());
		});
		dataArray2x = newData;
		option.hover = false;
		option.space = [10, 10, 10, 10];
		dataArray2x[0][1] = 1;
		option.colors[0] = 'rgba(120,120,120,.2)';
	}
	var charts;
	if (option.point) {
		let seData = dataArray2x.map(item => {
			return {
				name: item[0],
				y: item[1],
				color: item[2]
			};
		});
		charts = Highcharts.chart(dom, {
			credits: {
				enabled: false // 禁用版权信息
			},
			chart: {
				type: 'pie',
				backgroundColor: 'transparent',
				spacing: option.space
			},
			title: { text: '', style: {fontSize: '16px' }},
			tooltip: {
				enabled: false
			},

			plotOptions: {
				pie: {
					dataLabels: {
						// useHTML:true,
						enabled: (option.dataLabelsFormat != undefined) ? option.dataLabelsFormat : false // 不显示图例
						// format: (option.dataLabelsFormat != undefined) ? option.dataLabelsFormat : '{point.name}: <b>{point.y}</b>'
					},
					point: {
						events: {
							mouseOver: function (e) { // 鼠标滑过时动态更新标题
								if (option.pointTitle) {
									charts.setTitle({
										text: e.target.y + '%' + '<br />' + e.target.name
									});
								} else {
									charts.setTitle({
										text: e.target.name !== getLanguageStr('diagnosis58', '未执行电站') ? e.target.y + '<br>' + i18n.t('diagnosis57', [e.target.name, 'x级电站']) : e.target.y + '<br>' + e.target.name
									});
								}
							}
						}
					},
					showInLegend: option.showInLegend,
					enableMouseTracking: option.hover, // 禁用交互
					colors: option.colors,
					borderWidth: 0,
					slicedOffset: (option.hover) ? 10 : 0,
					// size:($target.width()>$target.height())?$target.height():$target.width(),
					// innerSize:($target.width()>$target.height())?$target.height()-10*2-lineW*2:$target.width()-10*2-lineW*2
					innerSize: (100 - option.lineW) + '%'
				}
			},
			series: [{
				data: seData
			}]
		});
	} else {
		charts = Highcharts.chart(dom, {
			credits: {
				enabled: false // 禁用版权信息
			},
			chart: {
				type: 'pie',
				backgroundColor: 'transparent',
				spacing: option.space
			},
			title: { text: '' },
			tooltip: getTooltip('ring'),
			plotOptions: {
				pie: {
					dataLabels: {
						// useHTML:true,
						enabled: (option.dataLabelsFormat != undefined) ? option.dataLabelsFormat : false // 不显示图例
						// format: (option.dataLabelsFormat != undefined) ? option.dataLabelsFormat : '{point.name}: <b>{point.y}</b>'
					},
					showInLegend: option.showInLegend,
					enableMouseTracking: option.hover, // 禁用交互
					colors: option.colors,
					borderWidth: 0,
					slicedOffset: (option.hover) ? 10 : 0,
					// size:($target.width()>$target.height())?$target.height():$target.width(),
					// innerSize:($target.width()>$target.height())?$target.height()-10*2-lineW*2:$target.width()-10*2-lineW*2
					innerSize: (100 - option.lineW) + '%'
				}
			},
			series: [{
				data: dataArray2x
			}]
		});
	}

	if (option.end) option.end.call($target, dataArray2x);
	return charts;
}
export function drawSolidgauge (dom, dataArray) {
	/* dataArray={
		width:5, //环的宽度
		balance:0,//内外环相差
		data:[25,30],
		color:['',''],
		background:''
	} */
	if (!dataArray.color) dataArray.color = stage.color.list;
	let paneBackground = new Array();
	let series = new Array();
	dataArray.data.forEach((item, index) => {
		paneBackground.push({
			outerRadius: `${100 - index * dataArray.width - index - dataArray.balance}%`,
			innerRadius: `${100 - (index + 1) * dataArray.width - index - dataArray.balance}%`,
			backgroundColor: dataArray.background,
			borderWidth: 0
		});
		series.push({
			color: dataArray.color[index],
			radius: `${100 - index * dataArray.width - index}%`,
			innerRadius: `${100 - (index + 1) * dataArray.width - index - dataArray.balance}%`,
			y: dataArray.data[index]
		});
	});
	// console.log(series)
	Highcharts.chart(dom, {
		credits: {
			enabled: false // 禁用版权信息
		},
		chart: {
			type: 'solidgauge',
			backgroundColor: 'transparent',
			spacing: [0, 0, 0, 0]
		},
		title: {
			text: ''
		},
		tooltip: {
			enabled: false
		},
		pane: {
			startAngle: 0,
			endAngle: 360,
			size: '100%',
			background: paneBackground
		},
		yAxis: {
			min: 0,
			max: 100,
			lineWidth: 0,
			tickPositions: []
		},
		plotOptions: {
			solidgauge: {
				dataLabels: {
					enabled: false
				},
				linecap: 'round',
				stickyTracking: false
			}
		},
		series: [{
			data: series
		}]
	});
}
export function drawGauge ($target, dataArray2x, tipName, colors) { // 绘制指针环
	if (typeof (colors) !== 'object') colors = [stage.color.main, '#ccc'];
	$target.highcharts({
		credits: {
			enabled: false // 禁用版权信息
		},
		// legend:{enabled:false},关闭图例
		chart: {
			type: 'pie',
			backgroundColor: 'transparent',
			spacing: [0, 0, 0, 0]
		},
		title: { text: '' },
		subtitle: { text: '' },
		plotOptions: {
			pie: {
				dataLabels: {
					enabled: false // 不显示图例
				},
				// enableMouseTracking:false,	禁用交互
				colors: colors,
				borderWidth: 0,
				startAngle: -120,
				endAngle: 120,
				// slicedOffset:10,
				// size:($target.width()>$target.height())?$target.height():$target.width(),
				// innerSize:($target.width()>$target.height())?$target.height()-10*2-lineW*2:$target.width()-10*2-lineW*2
				innerSize: '92%'
			}
		},
		series: [{
			name: tipName,
			data: dataArray2x
		}]
	});
	var $arrow = $target.parents('.mainDataBox').find('.arrow'),
		maxData = dataArray2x[0][1] + dataArray2x[1][1];
	$arrow.css('transform', 'rotate(' + (dataArray2x[0][1] / maxData * (300 - 60) + 60) + 'deg)');
	$target.parents('.mainDataBox').find('.max').html(maxData);
}
/**
 *
 * @param {*} dom
 * @param {*} data
 * @param {*} optionNew :{
 * startDate:时间戳毫秒
 * }
 */
export function drawLine (dom, data, optionNew) {
	data.map(item => {
		if (item.dataType != 'weatherPic' && optionNew.yTitle) {
			let indexnow = optionNew.yTitle.indexOf(item.unit);
			item.yAxis = indexnow;
		}
	});
	// data[1].data.map(v=>{
	// 	v[1]=null;
	// });
	// data=[
	// 	{
	// 		name:"数据1电压",
	// 		unit:"V",
	// 		yAxis:0,
	// 		// dashStyle:lineStyle[0],
	// 		// color:colorSys.list[0],
	// 		// timeOffset:randomData({min:-12*60,max:12*60}),
	// dataType:"weatherPic",
	// 		data:[
	// 			[毫秒时间戳,null/Number],
	// 			....
	// 		]
	// 	},....
	// ]
	let weatherDataIndex = -1;// 存储天气数据索引号
	var option = {
		mode: 'def',
		customData: '', // 用于调取同一时间的所有数据展示
		marker: false,
		crosshairs: (optionNew.mode == 'min') ? false : { width: 1, color: '#9b9b9b' },
		yTitle: [''],
		colorGrid: '#80808028',
		colorAxisText: stage.color.neutral,
		legend: (data.length > 0),
		hover: true,
		spacing: [0, 0, 0, 0],
		timeType: 'day'
	};
	$.extend(true, option, {
		xAxis: {
			type: 'datetime',
			labels: {
				style: {
					color: optionNew.colorAxisText || option.colorAxisText
				},
				autoRotation: false,
				formatter: function () {
					var time = '';
					switch (option.timeType) {
					case 'day':
						time = Highcharts.dateFormat('%H:%M', this.value);
						if (option.mode == 'min') {
							if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 && time == '00:00') time = '24';
							else if (time == '00:00') time = '0';
							else time = '';
						} else if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 && time == '00:00') {
							// time="24:00";
							time = '';
						}
						break;
					case 'week':
						if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 * 7) {
							// time="24:00";
							time = '';
						} else {
							time = Highcharts.dateFormat('%m/%d', this.value);
							var week = new Date(this.value),
								weekStr = '';
							week = week.getDay();
							switch (week) {
							case 0:
								weekStr = getLanguageStr('word146', '周日');
								break;
							case 1:
								weekStr = getLanguageStr('word140', '周一');
								break;
							case 2:
								weekStr = getLanguageStr('word141', '周二');
								break;
							case 3:
								weekStr = getLanguageStr('word142', '周三');
								break;
							case 4:
								weekStr = getLanguageStr('word143', '周四');
								break;
							case 5:
								weekStr = getLanguageStr('word144', '周五');
								break;
							case 6:
								weekStr = getLanguageStr('word145', '周六');
								break;
							}
							time += '<br>' + weekStr;
						}
						break;
					case '':
						break;
					}
					return time;
					// if(this.value.split(" ").length>1){}
				}
			},
			startOnTick: false,
			// lineColor:optionNew.colorGrid||option.colorGrid,
			tickColor: optionNew.colorGrid || option.colorGrid
			// tickPixelInterval:600,
			// tickInterval:option.tickInterval
		},
		yAxis: {
			// allowDecimals: false,
			labels: {
				enabled: optionNew.mode != 'min',
				style: {
					color: optionNew.colorAxisText || option.colorAxisText
				}
			},
			title: {
				text: '',
				rotation: 0,
				align: 'high',
				offset: 20,
				x: 5,
				y: -20
			},
			lineWidth: (optionNew.mode == 'min') ? 1 : 0,
			lineColor: optionNew.colorGrid || option.colorGrid,
			gridLineColor: optionNew.colorGrid || option.colorGrid,
			// endOnTick:false,
			maxPadding: 0.01
		}
	});

	$.extend(option, optionNew);

	// if (option.yTitle.length > 2) option.spacing = [0, 30, 0, 30]
	// else option.spacing = [0, 0, 0, 0]
	if (option.legend == false) option.spacing[0] = stage.space;

	$(data).each(function (index) {
		if (this.data.length > 0) {
			if (option.startDate) {
				let delIndex = 0;
				while (delIndex < this.data.length) {
					if (this.data[delIndex][0] - stage.time.localOffset < option.startDate) {
						this.data.splice(delIndex, 1);// 删掉跨天数据
					} else {
						++delIndex;
					}
				}
			}
			// 头尾补数据，保持视图完整
			var date = new Date(this.data[0][0]);
			switch (option.timeType) { // 初始日期设定到当前或一周的第一天
			case 'day':
				break;
			case 'week':
				var addition = date.getUTCDay() == 0 ? -6 : (date.getUTCDay() - 1) * -1;
				date.setUTCDate(date.getUTCDate() + addition);
				break;
					// case "":break;
					// case "":break;
			}
			if (!option.startDate) option.startDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0); // 自动设置startDate
			if (this.data[0][0] != Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0)) {
				this.data.unshift([Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0), null]); // 补充当天的0点起点数据
			}
			if (this.data[this.data.length - 1][0] != Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + (option.timeType == 'day' ? 1 : 6), 0, 0, 0, 0)) {
				this.data.push([
					Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + (option.timeType == 'day' ? 1 : 6), 0, 0, 0, 0),
					null
				]); // 补充当天的24点起点数据
			}
		}
		if (this.dataType == 'weatherPic') {
			weatherDataIndex = index;
			if (option.legend == false) option.spacing[0] = stage.space * 4;// 仅图例禁用的时候通过这个留出天气图标展示位置
		}
		if (!this.fillColor && this.dataType != 'weatherPic') { // 处理特殊颜色
			this.fillColor = {
				linearGradient: {
					x1: 0,
					y1: 0,
					x2: 0,
					y2: 1
				},
				stops: [
					[0, Highcharts.Color(stage.color.list[index]).setOpacity(0.2).get('rgba')],
					[1, Highcharts.Color(stage.color.list[index]).setOpacity(0).get('rgba')]
				]
			};
		}
	});

	// 数据顺序检测
	$(data).each(function () {
		var now = 0,
			info = this.name;
		$(this.data).each(function () {
			if (this[0] < now) trace(info + ':' + this[0] + ',上一条时间：' + now);
			now = this[0];
		});
	});

	option.xAxis.tickInterval = (option.timeType == 'day') ? 3 * 3600 * 1000 : 24 * 3600 * 1000;
	if (optionNew.mode) {
		switch (optionNew.mode) {
		case 'min':
			option.hover = false;
			// optionNew.marker=false;
			option.spacing = [0, 0, 0, 1];
			option.yAxis.gridLineWidth = 0;
			option.yAxis.lineWidth = 1;
			option.xAxis.labels.y = 12;
			option.xAxis.tickPosition = 'inside';
			option.xAxis.tickLength = 5;
			option.xAxis.lineColor = '#ccc';
			option.xAxis.tickInterval = 24 * 3600 * 1000;
			option.legend = false;
			break;
		case '':
			break;
		default:
			// option.spacing=[0,40,0,40];//小spacing会导致y轴在有浮点数的情况下被截断
			break;
		}
	}
	if (option.customData == '') { // 组建数据
		option.customData = {};
		$(data).each(function (i) {
			if (!this.color) this.color = stage.color.list[i];
			let dataType = this.dataType;
			$(this.data).each(function (dataIndex) {
				var displayValue = dataType == 'weatherPic' ? this[2] : this[1];	// 定义tip中展示值
				if (this[1]) {
					// data[i].data[dataIndex]
					displayValue = $.isNumeric(displayValue) ? Math.round(displayValue * 100) / 100 : displayValue;	// 定义tip中展示值(数字则保留小数位，其余保留原始格式-例如字符串)
					this[1] = $.isNumeric(this[1]) ? Math.round(this[1] * 100) / 100 : this[1];	// 用于绘制图表(字符串转为null)
				}
				var willObj = {
					color: data[i].color, // stage.color.list[i]
					name: data[i].name,
					value: (displayValue == null || displayValue == undefined) ? '--' : displayValue,
					dataType: data[i].dataType,
					unit: data[i].unit,
					timeOffset: data[i].timeOffset,
					legendSelectIndex: i	// 当前参数数据的legend index值
					// panelData:this[2]||""
				};
				if (option.customData['t' + this[0]]) { // 已有该时间点的数据
					option.customData['t' + this[0]].push(willObj);
				} else { // 没有该时间点的数据
					option.customData['t' + this[0]] = [willObj];
				}
			});
		});
	}
	if (option.yTitle && option.yTitle.length == 1 && option.yTitle[0] == '%') { // 单个百分比图表固定呈现0-100
		option.yAxis = $.extend(option.yAxis, {
			min: 0,
			max: 100
			// title: {text: option.yTitle[0]}
		});
		option.yAxis.title.text = option.yTitle[0];
	} else if (option.yTitle && typeof (option.yTitle) === 'object') { // yAxis的处理
		var yTitleArray = [];
		$(option.yTitle).each(function (index, str) {
			var titleObj = {};
			$.extend(titleObj, option.yAxis);
			titleObj.title = {}; // 不清空会有引用问题
			$.extend(titleObj.title, option.yAxis.title);
			titleObj.title.style = {color: option.colorAxisText};
			titleObj.title.text = str;
			if ((index + 1) % 2 == 0) {
				titleObj.title.x = -5;
				titleObj.opposite = true;
			}
			yTitleArray.push(titleObj);
		});
		option.yAxis = yTitleArray;
	}
	// if (option.colors) {
	// 	$(data).each(function(index) {
	// 		this.color = option.colors[index];
	// 	});
	// }
	let chart = Highcharts.chart(dom, {
		credits: { enabled: false }, // 禁用版权信息
		title: { text: '' },
		chart: {
			type: 'areaspline',
			backgroundColor: 'transparent',
			showAxes: true,
			spacing: option.spacing
		},
		xAxis: option.xAxis,
		yAxis: option.yAxis,
		tooltip: {
			/*
			shared:true,
			valueSuffix:"kWh"
			*/
			// crosshairs:{width:1,color:(option.color&&data.length<=1)?	option.color:"#ccc"},
			crosshairs: option.hover, // crosshairs
			xDateFormat: '%Y/%m/%d %H:%M:%S',
			formatter: function () {
				var scope = this;
				this.y = Math.round(this.y * 100) / 100;
				var timeOffset = '';
				if ($.isNumeric(option.timeOffset)) {
					var operator = (option.timeOffset >= 0) ? '+' : '-';
					var timeOffset_h = Math.floor(Math.abs(option.timeOffset) / 60);
					var timeOffset_m = Math.abs(option.timeOffset) - timeOffset_h * 60;
					var timeOffset = ' (UTC' + operator + fill2str(timeOffset_h) + ':' + fill2str(timeOffset_m) + ')';
				}
				var head = Highcharts.dateFormat('%Y/%m/%d %H:%M:%S', this.x) + timeOffset + '<br>';
				// var body='<span style="color:'+this.color+';font-size:18px;">\u25CF</span> '+this.series.name+"："+this.y+this.series.userOptions.unit;
				var body = '';
				if (option.customData['t' + this.x]) {
					$(option.customData['t' + this.x]).each(function () {
						if ($(dom).find('.highcharts-series-' + this.legendSelectIndex + '.highcharts-legend-item-hidden').length == 0) {	// 当前参数legend激活才显示浮窗中当前参数数据
							var timeOffsetSingle = '';
							if (this.timeOffset != undefined) {
								var operator = (this.timeOffset >= 0) ? '+' : '-';
								var timeOffset_h = Math.floor(Math.abs(this.timeOffset) / 60);
								var timeOffset_m = Math.abs(this.timeOffset) - timeOffset_h * 60;
								var timeOffsetSingle = ' (UTC' + operator + fill2str(timeOffset_h) + ':' + fill2str(timeOffset_m) + ') ';
							}
							if (scope.color == this.color) body += '<span style="color:' + this.color + ';font-size:18px;">\u25CF</span>' + '<b> ' + this.name + timeOffsetSingle + '：' + getTypeText(this.value, 'weatherState') + ' ' + (this.unit || '') + '</b>' + '<br>';
							else body += '<span style="color:' + this.color + ';font-size:18px;">\u25CF</span> ' + this.name + timeOffsetSingle + '：' + getTypeText(this.value, 'weatherState') + ' ' + (this.unit || '') + '<br>';
						}
					});
				}
				// if(option.dataHover) option.dataHover(option.customData["t"+this.x][0].panelData||option.customData["t"+this.x]);
				if (option.dataHover) {
					option.dataHover({
						// dataX:option.timeType=="day"? this.x+top.timeObj.offset:this.x,
						dataX: this.x,
						dataY: this.y,
						customData: option.customData['t' + this.x]
					});
				}
				if (top.debugMode) {
					trace({ dataX: this.x, dataY: this.y });
				}
				return head + body;
			},
			enabled: option.hover
		},
		legend: {
			align: 'center',
			verticalAlign: 'top',
			symbolWidth: stage.space * 2,
			margin: weatherDataIndex >= 0 ? stage.space * 3 : stage.space * 2,
			itemDistance: stage.space,
			// itemWidth: stage.space * 10,
			itemStyle: {
				color: optionNew.colorAxisText || option.colorAxisText,
				'font-weight': 'normal',
				'font-family': 'unset'
				// "z-index":1
			},
			// y:-20,
			// useHTML:true,
			enabled: option.legend
		},
		plotOptions: {
			spline: {
				marker: {
					enabled: option.marker,
					symbol: 'circle',
					// radius: 2,
					states: {
						hover: {
							enabled: option.hover
						}
					}
				},
				states: {
					hover: {
						enabled: option.hover
					}
				},
				lineWidth: (option.mode == 'min') ? 1 : 2
			},
			areaspline: {
				marker: {
					enabled: option.marker,
					symbol: 'circle',
					// radius: 2,
					states: {
						hover: {
							enabled: option.hover
						}
					}
				},
				lineWidth: 1,
				states: {
					hover: {
						enabled: option.hover
					}
				},
				lineWidth: (option.mode == 'min') ? 1 : 2
			}
		},
		series: data // marker:{symbol:"url(image/bigstation.png)"},marker:{symbol: "square"},
	});
	// $target.highcharts().reflow();
	$(dom).find('.highcharts-legend-item').off('click');
	if (weatherDataIndex >= 0) { // 处理天气图表
		let size = stage.space * 2;
		let color = data[weatherDataIndex].color || this.color;
		$.each(chart.series[weatherDataIndex].data, function () {
			let str = data[weatherDataIndex].data[this.index][2];
			if (str) {
				let icoBox = chart.renderer.g()
					.attr({
						translateX: this.plotX + chart.plotLeft - size / 2,
						translateY: chart.plotTop - size
					})
					.clip(chart.renderer.clipRect(0, 0, size, size))
					.add();
				chart.renderer.html(`
					<svg class="weatherIco w2x h2x tra-fast" title="${str}" style="fill:${color}">
						<use xlink:href="#ico-weather-${str}"></use>
					</svg>
				`).add(icoBox);
			}
		});
		$(dom).find('.highcharts-legend-item').on('click', function () { // 点击天气图例，显示和隐藏数据
			if ($(this).hasClass('highcharts-series-' + weatherDataIndex)) {
				if ($(this).hasClass('highcharts-legend-item-hidden')) {
					$(this).parents('.highcharts-container').first().addClass('weatherHide');
				} else $(this).parents('.highcharts-container').first().removeClass('weatherHide');
			}
		});
	}
}
export function drawAlarmTime (dom, data, lastValidTime, optionNew) {
	var option = {
		yTitle: [''],
		xAxis: {
			type: 'datetime',
			labels: {
				autoRotation: false,
				formatter: function () {
					var time = '';
					time = Highcharts.dateFormat('%H:%M', this.value);
					if (option.mode == 'min') {
						if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 && time == '00:00') time = '24';
						else if (time == '00:00') time = '0';
						else time = '';
					} else if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 && time == '00:00') {
						// time="24:00";
						time = '';
					}
					return time;
				}
			},
			tickColor: optionNew.mode == 'display' ? '#80808032' : '#80808028'
		},
		hover: true,
		timeType: 'day'
	};
	$.extend(option, optionNew);
	option.yAxis.title = { text: '' };
	option.yAxis.labels = { enabled: false };
	option.yAxis.gridLineWidth = '0px';
	option.yAxis.lineWidth = 1;
	// 头尾补数据，保持视图完整
	var date = new Date(data[0][0]);
	let first = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0);
	if (!option.startDate) option.startDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0); // 自动设置startDate
	if (data[0][0] != first) {
		data.unshift([first, null, null]); // 补充当天的0点起点数据
	}
	if (data[data.length - 1][0] != Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + (option.timeType == 'day' ? 1 : 6), 0, 0, 0, 0)) {
		data.push([
			Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + (option.timeType == 'day' ? 1 : 6), 0, 0, 0, 0),
			null, null
		]); // 补充当天的24点起点数据
	}
	let now = 0;
	$(data).each(function (index) {
		if (this[0] < now) {
			trace('index:' + index + ' | ' + this[0] + ',上一条时间：' + now);
		} else now = this[0];
		// this[1] = 1
		// this[2] = 2
	});

	option.xAxis.tickInterval = 3 * 3600 * 1000;
	Highcharts.chart(dom, {
		credits: { enabled: false },	// 禁用版权信息
		chart: {
			type: 'arearange',
			backgroundColor: 'transparent',
			showAxes: true
		},
		title: { text: '' },
		xAxis: option.xAxis,
		yAxis: option.yAxis,
		plotOptions: {
			arearange: {
				marker: {
					enabled: false,
					states: {
						hover: {
							enabled: false
						}
					}
				}
			},
			series: {
				lineWidth: 0
			}
		},
		tooltip: getTooltip('alarmTime', optionNew.timezone),
		legend: { enabled: false },
		series: [{
			data: data
		}]
	});
}
export function drawChartArea ($target, data, optionNew) {
	var option = {
		customData: '', // 用于调取同一时间的所有数据展示
		yAxis: {
			allowDecimals: false,
			title: {
				text: '',
				rotation: 0,
				align: 'high',
				offset: 20,
				x: 5,
				y: -20
			},
			gridLineColor: '#edf0f4',
			endOnTick: false,
			maxPadding: 0.01
		},
		legend: true,
		timeType: 'day'
	};
	$.extend(option, optionNew);
	if (option.customData == '') { // 组建数据
		option.customData = {};
		$(data).each(function (i) {
			$(this.data).each(function () {
				if (option.customData['t' + this[0]]) { // 已有该时间点的数据
					option.customData['t' + this[0]].push({
						color: stage.color.list[i],
						name: data[i].name,
						value: this[1],
						unit: data[i].unit
					});
				} else { // 没有该时间点的数据
					option.customData['t' + this[0]] = [{
						color: stage.color.list[i],
						name: data[i].name,
						value: this[1],
						unit: data[i].unit
					}];
				}
			});
		});
	}
	if (option.yTitle && typeof (option.yTitle) === 'object') { // yAxis的处理
		var yTitleArray = [];
		$(option.yTitle).each(function (index, str) {
			var titleObj = {
				title: {
					rotation: 0,
					align: 'high',
					offset: 15,
					y: -20
				},
				gridLineColor: '#edf0f4',
				endOnTick: false,
				maxPadding: 0.01
			};
			titleObj.title.text = str;
			if ((index + 1) % 2 == 0) {
				titleObj.title.x = -5;
				titleObj.opposite = true;
			}
			yTitleArray.push(titleObj);
		});
		option.yAxis = yTitleArray;
	}
	if (option.startDate && option.startDate.constructor != Number) option.startDate = Date.parse(option.startDate);
	$target.highcharts({
		credits: { enabled: false }, // 禁用版权信息
		chart: {
			type: 'areaspline',
			backgroundColor: 'transparent',
			showAxes: true,
			spacing: [(option.legend) ? 10 : 40, 20 * optionNew.yTitle.length / 2, 10, 20 * optionNew.yTitle.length / 2]
		},
		title: { text: '' },
		subtitle: { text: '' },
		xAxis: {
			type: 'datetime',
			labels: {
				formatter: function () {
					var time = '';
					switch (option.timeType) {
					case 'day':
						time = Highcharts.dateFormat('%H:%M', this.value);
						if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 && time == '00:00') {
							// time="24:00";
							time = '';
						}
						break;
					case 'week':
						if (option.startDate && this.value >= option.startDate + 24 * 3600 * 1000 * 7) {
							// time="24:00";
							time = '';
						} else {
							time = Highcharts.dateFormat('%m/%d', this.value);
							var week = new Date(this.value),
								weekStr = '';
							week = week.getDay();
							switch (week) {
							case 0:
								weekStr = getLanguageStr('word146', '周日');
								break;
							case 1:
								weekStr = getLanguageStr('word140', '周一');
								break;
							case 2:
								weekStr = getLanguageStr('word141', '周二');
								break;
							case 3:
								weekStr = getLanguageStr('word142', '周三');
								break;
							case 4:
								weekStr = getLanguageStr('word143', '周四');
								break;
							case 5:
								weekStr = getLanguageStr('word144', '周五');
								break;
							case 6:
								weekStr = getLanguageStr('word145', '周六');
								break;
							}
							time += '<br>' + weekStr;
						}
						break;
					case '':
						break;
					}
					return time;
					// if(this.value.split(" ").length>1){}
				}
			},
			lineColor: '#858585',
			tickInterval: (option.timeType == 'day') ? 3 * 3600 * 1000 : 24 * 3600 * 1000
			/*
				dateTimeLabelFormats:{
					day:'%Y/%b/%e',
					hour:'%H:%M'
				},
				startOfWeek:0
				*/
		},
		yAxis: option.yAxis,
		legend: { // 图例
			verticalAlign: 'top',
			align: 'center',
			itemMarginBottom: 40,
			symbolWidth: 12,
			symbolRadius: 3,
			enabled: option.legend
			// enabled:(data.length>1)?	true:false
		},
		tooltip: {
			// shared:true,
			// crosshairs:{width:1,color:(option.color&&data.length<=1)?	option.color:"#ccc"},
			crosshairs: { width: 1, color: '#9b9b9b' },
			xDateFormat: '%Y/%m/%d %H:%M:%S',
			/*
			pointFormat:'{series.name} produced <b>{point.y:,.0f}</b><br/>warheads in {point.x}',
			*/
			formatter: function () {
				var scope = this;
				this.y = Math.round(this.y * 100) / 100;
				var head = Highcharts.dateFormat('%Y/%m/%d %H:%M:%S', this.x) + '<br>';
				// var body='<span style="color:'+this.color+';font-size:18px;">\u25CF</span> '+this.series.name+"："+this.y+this.series.userOptions.unit;
				var body = '';
				if (option.customData['t' + this.x]) {
					$(option.customData['t' + this.x]).each(function () {
						if (scope.color == this.color) body += '<span style="color:' + this.color + ';font-size:18px;">\u25CF</span>' + '<b> ' + this.name + '：' + this.value + this.unit + '</b>' + '<br>';
						else body += '<span style="color:' + this.color + ';font-size:18px;">\u25CF</span> ' + this.name + '：' + this.value + this.unit + '<br>';
					});
				}
				return head + body;
			}
		},
		plotOptions: {
			areaspline: {
				marker: {
					enabled: false,
					symbol: 'circle',
					radius: 2,
					states: {
						hover: {
							enabled: true,
							lineWidth: 2,
							// lineColor:option.color,
							// fillColor:"#fff",
							radius: 5
						}
					}
				},
				states: {
					hover: {
						lineWidth: 1,
						halo: { size: 0 }
					}
				},
				color: option.color,
				lineWidth: 1,
				fillOpacity: 0.2
			},
			series: {
				// pointStart:option.startDate,
				// pointInterval:3*3600*1000
			}
		},
		series: data
	});
}
export function drawColumn (dom, data, optionNew) { // optionNew:{yTitle:String,color:String,xCategories:Array}
	// data=[
	// 	{
	// 		name:"String",
	// 		unit:"String",
	//		type:"areaspline",column,arearange支持多种数据表现形式
	// 		yAxis:int,
	// 		data:[]
	// 	},....
	// ]

	data.forEach(item => {
		if (item.dataType == 'weatherPic') {
			 item.type = 'arearange';
		}
	});
	let weatherDataIndex = -1;// 存储天气数据索引号
	// let customData;//存储tooTip需要的数据
	var option = {
		yTitle: [''],
		// color:"",
		colorAdv: [], // 渐变色序列处理
		// colorByPoint:false,
		colorGrid: '#80808028',
		colorAxisText: stage.color.neutral,
		legend: true,
		xOpposite: false,
		inverted: false,
		canSelect: false// 是否能够选中单条数据
	};

	$.extend(true, option, {
		xAxis: {
			labels: {
				style: {
					color: optionNew.colorAxisText || option.colorAxisText
				},
				formatter: function () {
					var out = String(this.value).split('-').pop();
					// if(this.value.split("/").length>1)	out=this.value.split("/").pop();
					// else if(this.value.split("/").length>2)	out=this.value.split("/").pop();
					if (option.timeType) {
						switch (option.timeType.split(',')[0]) {
						case 'week':
							out = out.split(' ')[0] + '<br>' + out.split(' ')[1];
							break;
						case 'all':
							if (Number(out) > Number(option.timeType.split(',')[1])) out = '';
							break;
								// case "":
								// 	break;
								// default:
								// 	break;
						}
					} else if (!option.xCategories) {
						++out;
					}
					return out;
					// return Highcharts.dateFormat('%m/%d',this.value);
				}
			},
			lineColor: optionNew.colorGrid || option.colorGrid,
			tickColor: optionNew.colorGrid || option.colorGrid
		}
	});
	// 更具长度分行显示
	if (optionNew.formatterL) {
		option.xAxis.labels.formatter = function () {
			let out;
			if (this.value.length > 17) {
				out =	this.value.substr(0, 17) + '<br>' + this.value.substr(17);
			}
			return out;
		};
	}
	$.extend(true, option, optionNew);

	if (option.xCategories) { // xAxis的处理
		option.xAxis.categories = option.xCategories;
		if (data.length > 1) option.xAxis.crosshair = true;
	}
	if (option.yAxis && option.yAxis.visible != false || !option.yAxis) {
		if (option.yTitle && typeof (option.yTitle) === 'object') { // yAxis的处理
			var yTitleArray = [];
			$(option.yTitle).each(function (index, str) {
				var titleObj = {
					title: {
						style: {color: option.colorAxisText},
						rotation: 0,
						align: 'high',
						offset: 20,
						x: 5,
						y: -20
					},
					labels: {
						style: {color: option.colorAxisText}
					},
					// lineColor:option.mode=="display"?"#80808032":'#80808028',
					gridLineColor: option.colorGrid,
					// endOnTick:false,
					maxPadding: 0.01,
					allowDecimals: false
				};
				titleObj.title.text = str;
				if ((index + 1) % 2 == 0) {
					titleObj.title.x = -5;
					titleObj.opposite = true;
				}
				yTitleArray.push(titleObj);
			});
			option.yAxis = yTitleArray;
		}
	}
	if (option.plotLines) {
		option.yAxis[0].plotLines = option.plotLines;
		option.yAxis[0].lineWidth = 1;
	}
	if (optionNew.Hasmax) {
		option.yAxis[0].max = optionNew.Hasmax;
	}

	// if (option.colors) { //data颜色的处理
	// 	$(option.colors).each(function(index, str) {
	// 		data[index].color = str;
	// 	});
	// } else {
	// 	$(data).each(function(index) {
	// 		data[index].color = stage.color.list[index];
	// 	});
	// }
	$.each(data, function (index) {
		this.legendSelectIndex = index;	// 当前参数数据的legend index值
		if (this.dataType == 'weatherPic') {
			weatherDataIndex = index;
		}
		if (option.colorAdv.length) { // 处理特殊颜色
			if (!this.color) {
				this.color = {
					linearGradient: {
						x1: 0,
						y1: 0,
						x2: 0,
						y2: 1
					},
					stops: [
						[0, option.colorAdv[index]],
						[1, Highcharts.Color(option.colorAdv[index]).brighten(0.2).get('rgba')]
					]
				};
			}
		}
	});
	// if(option.isExchange){
	// 	 let copy = Object.assign({},option.xAxis)
	// 	 option.xAxis =Object.assign({}, option.yAxis)
	// 	 option.yAxis = copy
	// }

	// console.log(option.xAxis,option.yAxis,data)
	let chart = Highcharts.chart(dom, {
		credits: {
			enabled: false // 禁用版权信息
		},
		chart: {
			type: 'column',
			backgroundColor: 'transparent',
			showAxes: true,
			inverted: option.inverted,
			// marginTop: optionNew.plotLines?0:stage.space*3,
			spacing: [(option.mode == 'display' ? stage.space * 4 : 0), 15 * option.yTitle.length / 2, 0, 15 * option.yTitle.length / 2]
		},
		title: { text: '' },
		xAxis: option.xAxis,
		yAxis: option.yAxis,
		legend: {
			enabled: option.legend,
			verticalAlign: 'top',
			// itemMarginBottom: weatherDataIndex >= 0 ? stage.space * 3 : 0,
			margin: weatherDataIndex >= 0 ? stage.space * 3 : stage.space * 2,
			symbolWidth: stage.space,
			symbolRadius: stage.space / 4,
			itemStyle: {
				color: option.colorAxisText,
				'font-weight': 'normal',
				'font-family': 'unset'
			}
		}, // 图例
		plotOptions: {
			column: {
				// pointPadding:0.2
				borderRadius: 3
				// color:{
				// 	linearGradient: {
				// 		x1: 0,
				// 		y1: 0,
				// 		x2: 0,
				// 		y2: 1
				// 	},
				// 	// stops: [
				// 	// 	[0,option.color],
				// 	// 	[1,Highcharts.Color(option.color).brighten(.4).get('rgba')]
				// 	// ]
				// }
			},
			area: {
				fillColor: {
					linearGradient: {
						x1: 0,
						y1: 0,
						x2: 0,
						y2: 1
					},
					stops: [
						[0, option.sColor],
						[1, option.eColor]
					]
				}
			},
			areaspline: {
				allowPointSelect: option.canSelect,
				fillColor: {
					linearGradient: {
						x1: 0,
						y1: 0,
						x2: 0,
						y2: 1
					},
					stops: [
						[0, Highcharts.Color(stage.color.main).setOpacity(0.2).get('rgba')],
						[1, Highcharts.Color(stage.color.main).setOpacity(0).get('rgba')]
					]
				},
				marker: {
					fillColor: '#ffffff',
					 lineWidth: stage.space / 6,
					 lineColor: null,
					 states: {
						select: {
							// radius:stage.space
							fillColor: stage.color.main,
							// ,lineWidth:stage.space
							 lineColor: stage.color.main
						}
					}
				},
				lineWidth: 1,
				states: {
					hover: {
						lineWidth: 1
					}
				}
			},
			series: {
				allowPointSelect: option.canSelect,
				// colorByPoint:false,
				// color:{
				// 	linearGradient: {
				// 		x1: 0,
				// 		y1: 0,
				// 		x2: 0,
				// 		y2: 1
				// 	},
				// 	stops: [
				// 		[0,"#ff0000"],
				// 		[1,Highcharts.Color(option.color).brighten(-.8).get('rgba')]
				// 	]
				// },
				groupPadding: (option.xCategories.length == 1) ? 0.46 : 0.2,
				borderWidth: 0,
				maxPointWidth: 15,
				point: {
					events: {
						click: function () {
							if (option.onSelect) option.onSelect(this);
							// var text = this.category + ': ' + this.y + ' was last selected',
							// chart = this.series.chart;
							// if (!chart.lbl) {
							// 	chart.lbl = chart.renderer.label(text, 100, 70)
							// 		.attr({
							// 		padding: 10,
							// 		r: 5,
							// 		fill:stage.color.main,//Highcharts.getOptions().colors[1]
							// 		zIndex: 5
							// 	})
							// 		.css({
							// 		color: '#FFFFFF'
							// 	})
							// 		.add();
							// } else {
							// 	chart.lbl.attr({
							// 		text: text
							// 	});
							// }
						}
					}
				}
			}
		},
		tooltip: option.tooltip ? option.tooltip : getTooltip('column', $.extend(true, {}, option, {data}), dom),	// 传参dom以获取当前图表legend
		/*
		series: [{
			name:'数据',
			colorByPoint:(option.color==undefined||option.color=="")?	true:false,
			data:data
		}]
		*/
		series: data
	});
	$(dom).find('.highcharts-legend-item').off('click');
	if (weatherDataIndex >= 0) { // 处理天气图表
		let size = stage.space * 1.5;
		$.each(chart.series[weatherDataIndex].data, function () {
			this.y = data[weatherDataIndex].data[this.x];
			if (this.y) {
				let icoBox = chart.renderer.g()
					.attr({
						translateX: this.plotX + chart.plotLeft - size / 2,
						translateY: chart.plotTop - size
					})
					.clip(chart.renderer.clipRect(0, 0, size, size))
					.add();
				chart.renderer.html(`
					<svg class="weatherIco w105x h105x tra-fast" title="${this.y}" style="fill:${this.color}">
						<use xlink:href="#ico-weather-${this.y}"></use>
					</svg>
				`).add(icoBox);
			}
		});
		$(dom).on('click', '.highcharts-legend-item', function () { // 点击天气图例，显示和隐藏数据
			if ($(this).hasClass('highcharts-series-' + weatherDataIndex)) {
				if ($(this).hasClass('highcharts-legend-item-hidden')) {
					$(this).parents('.highcharts-container').first().addClass('weatherHide');
				} else $(this).parents('.highcharts-container').first().removeClass('weatherHide');
			}
		});
	}
	return chart;
}
export function drawColumnRange ($target, data, optionNew) {
	var option = {
		xCategories: '',
		after: '',
		colors: null
	};
	$.extend(option, optionNew);
	if (option.colors) {
		var newColors = [];
		$(data[0].data).each(function (index, myData) {
			if (index == 0 || index == data[0].data.length - 1) {
				newColors.push(option.colors[0]);
			} else {
				newColors.push(option.colors[1]);
			}
			/*
			var newData={
				y:myData,
				color:(index==0||index==data[0].data.length-1)?	option.colors[1]:option.colors[0]
			};
			data[0].data[index]=newData;
			*/
		});
		option.colors = newColors;
	}
	Highcharts.setOptions({
		colors: option.colors
	});
	$target.highcharts({
		credits: { enabled: false }, // 禁用版权信息
		title: { text: '' },
		chart: {
			type: 'columnrange',
			showAxes: true,
			inverted: true
		},
		xAxis: {
			categories: option.xCategories
		},
		yAxis: {
			min: 0,
			title: {
				text: ''
			}
		},
		tooltip: {
			formatter: function () { // console.log(this.point)
				return this.point.category + ':<b>' + Math.round((this.point.high - this.point.low) * 100) / 100 + option.after + '<b>';
			}
		},
		plotOptions: {
			columnrange: {
				dataLabels: {
					enabled: true,
					formatter: function () { // console.log(this.point)
						if (this.y == this.point.high) {
							return Math.round((this.point.high - this.point.low) * 100) / 100 + option.after;
						}
					}
				}
			},
			series: {
				colorByPoint: true
			}
		},
		legend: {
			enabled: false
		},
		series: data
	});
}
export function drawScatter ($target, data, optionNew) {
	var option = { yTitle: '', colors: null };
	$.extend(option, optionNew);
	if (option.colors) {
		$(data).each(function (index) {
			this.color = option.colors[index];
		});
	}
	$target.highcharts({
		credits: { enabled: false }, // 禁用版权信息
		chart: {
			type: 'scatter',
			zoomType: 'x', // xy
			backgroundColor: 'transparent',
			spacing: [10, 0, 20, 0]
		},
		title: { text: '' },
		subtitle: { text: '' },
		xAxis: {
			type: 'datetime',
			minRange: 3600 * 60 * 24,
			dateTimeLabelFormats: {
				day: '%e. %m',
				hour: '%H:%M'
			},
			/*
			labels: {
				formatter: function() {
					return  Highcharts.dateFormat('%H:%M', this.value);
				}
			},
			*/
			startOfWeek: 0,
			startOnTick: true,
			endOnTick: true,
			showLastLabel: true
		},
		yAxis: {
			title: { text: option.yTitle }
			// minRange:10
		},
		legend: {
			align: 'center',
			verticalAlign: 'top',
			/*
			layout: 'vertical',
			x: 100,
			y: 70,
			floating:true,
			borderWidth:1,
			backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
			*/
			enabled: (data.length > 1)
		},
		plotOptions: {
			scatter: {
				marker: {
					radius: 5,
					// fillColor:"rgba(0,0,0,0)",
					lineColor: 'rgba(255,255,255,.8)',
					lineWidth: 1,
					states: {
						hover: {
							radius: 4,
							enabled: true
						}
					}
				},
				states: {
					hover: {
						marker: {
							enabled: false
						}
					}
				}
			}
		},
		tooltip: {
			// xDateFormat:"%H:%M",
			// xDateFormat:'%Y/%m/%d'
			// dateTimeLabelFormats:{hour:"%A, %b %e, %H:%M"}
			formatter: function () {
				return Highcharts.dateFormat('%Y/%m/%d %H:%M:%S', this.x) + '<br><b>' + this.y + '</b>';
			}
		},
		/*
		 */
		series: data
	});
}
export function drawMixChart ($target, data, optionNew) {
	var option = {
		// crosshairs:null,
		xCategories: null,
		yAxis: { labels: { enabled: false }, title: { enabled: false } },
		legend: (data.length > 1),
		grouping: true
	};
	$.extend(option, optionNew);
	if (option.yTitle && typeof (option.yTitle) === 'object') { // yAxis的处理
		var yTitleArray = [];
		$(option.yTitle).each(function (index, str) {
			var titleObj = { title: {} };
			if (option.yTitleAlign == 'top') {
				titleObj.title = {
					rotation: 0,
					align: 'high',
					offset: 15,
					y: -20
				};
			}
			titleObj.title.text = str;
			if ((index + 1) % 2 == 0) {
				titleObj.opposite = true;
			}
			if (option.lineWidthX != undefined) titleObj.gridLineWidth = option.lineWidthX;
			if (option.lineWidthY != undefined) titleObj.lineWidth = option.lineWidthY;
			yTitleArray.push(titleObj);
		});
		option.yAxis = yTitleArray;
	}
	$target.highcharts({
		credits: { enabled: false }, // 禁用版权信息
		chart: {
			// zoomType: 'xy'
		},
		title: { text: '' },
		xAxis: [{
			categories: option.xCategories,
			labels: {
				formatter: function () {
					if (option.dateUse) {
						var str = String(this.value).split('-');
						switch (option.dateUse) {
						case 'y':
							str = str[0];
							break;
						case 'm':
							str = str[1];
							break;
						case 'd':
							str = str[2];
							break;
						case '':
							break;
						}
						return str;
					} else return this.value;
				}
			}
		}],
		yAxis: option.yAxis,
		tooltip: {
			shared: true,
			backgroundColor: '#7a7a7a',
			borderColor: '#7a7a7a',
			style: { color: '#fff', padding: '15px' }
		},
		plotOptions: {
			column: {
				grouping: option.grouping,
				shadow: false,
				borderWidth: 0
			},
			series: {
				// colorByPoint:option.colorByPoint,
				// color:option.color,
				// borderWidth:0,
				maxPointWidth: 20
			}
		},
		legend: {
			// layout: 'vertical',
			align: 'center',
			verticalAlign: 'top',
			floating: false,
			backgroundColor: 'none',
			symbolWidth: 12,
			symbolRadius: 5
		},
		series: data
	});
}

function drawMapCharts (target, data) {
	var maxNumber, numberArray = [];
	$(data[0].data).each(function () {
		numberArray.push(this.value);
	});
	maxNumber = Math.max.apply(null, numberArray) * 1.2;
	var chart = echarts.init(target, 'macarons');
	var option = {
		title: {
			// text:'',
			// subtext:'',
			left: 'center',
			show: false,
			padding: 0,
			itemGap: 0
		},
		tooltip: {
			trigger: 'item'
		},
		legend: {
			orient: 'vertical',
			left: 'left',
			data: ['iphone5'],
			show: false
		},
		visualMap: {
			min: 0,
			max: maxNumber,
			left: 'left',
			top: 'bottom',
			text: ['高', '低'], // 文本，默认为数值文本
			calculable: true
		},
		toolbox: {
			show: true,
			orient: 'vertical',
			left: 'left',
			top: 'center',
			feature: {
				// dataView:{readOnly: false},
				// restore:{},
				saveAsImage: {}
			}
		},
		itemStyle: {
			/*
			normal: {
				shadowBlur:100,
				shadowColor:'rgba(0, 0, 0, 0.1)'
			},
			*/
			emphasis: {
				shadowBlur: 20,
				shadowColor: 'rgba(0, 0, 0, 0.2)'
			}
		},
		series: data
	};
	chart.setOption(option);
}

function drawMapCity (target, data) {
	var chart = echarts.init(target, 'macarons');
	var geoCoordMap = {
		'海门': [121.15, 31.89],
		'鄂尔多斯': [109.781327, 39.608266],
		'招远': [120.38, 37.35],
		'舟山': [122.207216, 29.985295],
		'齐齐哈尔': [123.97, 47.33],
		'盐城': [120.13, 33.38],
		'赤峰': [118.87, 42.28],
		'青岛': [120.33, 36.07],
		'乳山': [121.52, 36.89],
		'金昌': [102.188043, 38.520089],
		'泉州': [118.58, 24.93],
		'莱西': [120.53, 36.86],
		'日照': [119.46, 35.42],
		'胶南': [119.97, 35.88],
		'南通': [121.05, 32.08],
		'拉萨': [91.11, 29.97],
		'云浮': [112.02, 22.93],
		'梅州': [116.1, 24.55],
		'文登': [122.05, 37.2],
		'上海': [121.48, 31.22],
		'攀枝花': [101.718637, 26.582347],
		'威海': [122.1, 37.5],
		'承德': [117.93, 40.97],
		'厦门': [118.1, 24.46],
		'汕尾': [115.375279, 22.786211],
		'潮州': [116.63, 23.68],
		'丹东': [124.37, 40.13],
		'太仓': [121.1, 31.45],
		'曲靖': [103.79, 25.51],
		'烟台': [121.39, 37.52],
		'福州': [119.3, 26.08],
		'瓦房店': [121.979603, 39.627114],
		'即墨': [120.45, 36.38],
		'抚顺': [123.97, 41.97],
		'玉溪': [102.52, 24.35],
		'张家口': [114.87, 40.82],
		'阳泉': [113.57, 37.85],
		'莱州': [119.942327, 37.177017],
		'湖州': [120.1, 30.86],
		'汕头': [116.69, 23.39],
		'昆山': [120.95, 31.39],
		'宁波': [121.56, 29.86],
		'湛江': [110.359377, 21.270708],
		'揭阳': [116.35, 23.55],
		'荣成': [122.41, 37.16],
		'连云港': [119.16, 34.59],
		'葫芦岛': [120.836932, 40.711052],
		'常熟': [120.74, 31.64],
		'东莞': [113.75, 23.04],
		'河源': [114.68, 23.73],
		'淮安': [119.15, 33.5],
		'泰州': [119.9, 32.49],
		'南宁': [108.33, 22.84],
		'营口': [122.18, 40.65],
		'惠州': [114.4, 23.09],
		'江阴': [120.26, 31.91],
		'蓬莱': [120.75, 37.8],
		'韶关': [113.62, 24.84],
		'嘉峪关': [98.289152, 39.77313],
		'广州': [113.23, 23.16],
		'延安': [109.47, 36.6],
		'太原': [112.53, 37.87],
		'清远': [113.01, 23.7],
		'中山': [113.38, 22.52],
		'昆明': [102.73, 25.04],
		'寿光': [118.73, 36.86],
		'盘锦': [122.070714, 41.119997],
		'长治': [113.08, 36.18],
		'深圳': [114.07, 22.62],
		'珠海': [113.52, 22.3],
		'宿迁': [118.3, 33.96],
		'咸阳': [108.72, 34.36],
		'铜川': [109.11, 35.09],
		'平度': [119.97, 36.77],
		'佛山': [113.11, 23.05],
		'海口': [110.35, 20.02],
		'江门': [113.06, 22.61],
		'章丘': [117.53, 36.72],
		'肇庆': [112.44, 23.05],
		'大连': [121.62, 38.92],
		'临汾': [111.5, 36.08],
		'吴江': [120.63, 31.16],
		'石嘴山': [106.39, 39.04],
		'沈阳': [123.38, 41.8],
		'苏州': [120.62, 31.32],
		'茂名': [110.88, 21.68],
		'嘉兴': [120.76, 30.77],
		'长春': [125.35, 43.88],
		'胶州': [120.03336, 36.264622],
		'银川': [106.27, 38.47],
		'张家港': [120.555821, 31.875428],
		'三门峡': [111.19, 34.76],
		'锦州': [121.15, 41.13],
		'南昌': [115.89, 28.68],
		'柳州': [109.4, 24.33],
		'三亚': [109.511909, 18.252847],
		'自贡': [104.778442, 29.33903],
		'吉林': [126.57, 43.87],
		'阳江': [111.95, 21.85],
		'泸州': [105.39, 28.91],
		'西宁': [101.74, 36.56],
		'宜宾': [104.56, 29.77],
		'呼和浩特': [111.65, 40.82],
		'成都': [104.06, 30.67],
		'大同': [113.3, 40.12],
		'镇江': [119.44, 32.2],
		'桂林': [110.28, 25.29],
		'张家界': [110.479191, 29.117096],
		'宜兴': [119.82, 31.36],
		'北海': [109.12, 21.49],
		'西安': [108.95, 34.27],
		'金坛': [119.56, 31.74],
		'东营': [118.49, 37.46],
		'牡丹江': [129.58, 44.6],
		'遵义': [106.9, 27.7],
		'绍兴': [120.58, 30.01],
		'扬州': [119.42, 32.39],
		'常州': [119.95, 31.79],
		'潍坊': [119.1, 36.62],
		'重庆': [106.54, 29.59],
		'台州': [121.420757, 28.656386],
		'南京': [118.78, 32.04],
		'滨州': [118.03, 37.36],
		'贵阳': [106.71, 26.57],
		'无锡': [120.29, 31.59],
		'本溪': [123.73, 41.3],
		'克拉玛依': [84.77, 45.59],
		'渭南': [109.5, 34.52],
		'马鞍山': [118.48, 31.56],
		'宝鸡': [107.15, 34.38],
		'焦作': [113.21, 35.24],
		'句容': [119.16, 31.95],
		'北京': [116.46, 39.92],
		'徐州': [117.2, 34.26],
		'衡水': [115.72, 37.72],
		'包头': [110, 40.58],
		'绵阳': [104.73, 31.48],
		'乌鲁木齐': [87.68, 43.77],
		'枣庄': [117.57, 34.86],
		'杭州': [120.19, 30.26],
		'淄博': [118.05, 36.78],
		'鞍山': [122.85, 41.12],
		'溧阳': [119.48, 31.43],
		'库尔勒': [86.06, 41.68],
		'安阳': [114.35, 36.1],
		'开封': [114.35, 34.79],
		'济南': [117, 36.65],
		'德阳': [104.37, 31.13],
		'温州': [120.65, 28.01],
		'九江': [115.97, 29.71],
		'邯郸': [114.47, 36.6],
		'临安': [119.72, 30.23],
		'兰州': [103.73, 36.03],
		'沧州': [116.83, 38.33],
		'临沂': [118.35, 35.05],
		'南充': [106.110698, 30.837793],
		'天津': [117.2, 39.13],
		'富阳': [119.95, 30.07],
		'泰安': [117.13, 36.18],
		'诸暨': [120.23, 29.71],
		'郑州': [113.65, 34.76],
		'哈尔滨': [126.63, 45.75],
		'聊城': [115.97, 36.45],
		'芜湖': [118.38, 31.33],
		'唐山': [118.02, 39.63],
		'平顶山': [113.29, 33.75],
		'邢台': [114.48, 37.05],
		'德州': [116.29, 37.45],
		'济宁': [116.59, 35.38],
		'荆州': [112.239741, 30.335165],
		'宜昌': [111.3, 30.7],
		'义乌': [120.06, 29.32],
		'丽水': [119.92, 28.45],
		'洛阳': [112.44, 34.7],
		'秦皇岛': [119.57, 39.95],
		'株洲': [113.16, 27.83],
		'石家庄': [114.48, 38.03],
		'莱芜': [117.67, 36.19],
		'常德': [111.69, 29.05],
		'保定': [115.48, 38.85],
		'湘潭': [112.91, 27.87],
		'金华': [119.64, 29.12],
		'岳阳': [113.09, 29.37],
		'长沙': [113, 28.21],
		'衢州': [118.88, 28.97],
		'廊坊': [116.7, 39.53],
		'菏泽': [115.480656, 35.23375],
		'合肥': [117.27, 31.86],
		'武汉': [114.31, 30.52],
		'大庆': [125.03, 46.58]
	};
	var convertData = function (data) {
		var res = [];
		for (var i = 0; i < data.length; i++) {
			var geoCoord = geoCoordMap[data[i].name];
			if (geoCoord) {
				res.push({
					name: data[i].name,
					value: geoCoord.concat(data[i].value)
				});
			}
		}
		return res;
	};

	option = {
		// backgroundColor: '#404a59',
		title: {
			text: '',
			subtext: '',
			left: 'center',
			textStyle: {
				color: '#fff'
			}
		},
		tooltip: {
			trigger: 'item'
		},
		/*
		legend: {
			orient: 'vertical',
			y: 'bottom',
			x:'right',
			data:['pm2.5'],
			textStyle: {
				color: '#fff'
			}
		},
		*/
		geo: {
			map: 'china',
			label: {
				emphasis: {
					show: false
				}
			},
			roam: true,
			itemStyle: {
				normal: {
					areaColor: '#f0f0f0', // 区域颜色
					borderColor: '#fff' // 区域border颜色
				},
				emphasis: {
					areaColor: '#e5e5e5' // 区域hover颜色
				}
			}
		},
		series: [{
			name: '数据',
			type: 'scatter',
			coordinateSystem: 'geo',
			data: convertData(data),
			symbolSize: function (val) {
				return val[2] / 10;
			},
			label: {
				normal: {
					formatter: '{b}',
					position: 'right',
					show: false
				},
				emphasis: {
					show: true
				}
			},
			itemStyle: {
				normal: {
					color: 'rgba(0,147,255,.8)' // 小圆点颜色
				}
			}
		},
		{
			name: 'Top 5',
			type: 'effectScatter',
			coordinateSystem: 'geo',
			data: convertData(data.sort(function (a, b) {
				return b.value - a.value;
			}).slice(0, 6)),
			symbolSize: function (val) {
				return val[2] / 10;
			},
			showEffectOn: 'render',
			rippleEffect: {
				brushType: 'stroke'
			},
			hoverAnimation: true,
			label: {
				normal: {
					formatter: '{b}',
					position: 'right',
					show: true
				}
			},
			itemStyle: {
				normal: {
					color: 'rgba(0,147,255,.8)', // 大圆点颜色
					shadowBlur: 20,
					shadowColor: 'rgba(0,0,0,.2)'
				}
			},
			zlevel: 1
		}
		]
	};
	chart.setOption(option);
}

// 绘制圆环
// const colorSys={	//设置全局的颜色列表，供图表使用
// 	blue:"#0093ff",
// 	blueLight:"#4ecde2",
// 	red:"#ff595f",
// 	yellow:"#fdc559",
// 	green:"#21ad5c",
// 	greenLight:"#15d0bb",
// 	orange:"#f39800",
// 	list:[]
// };
// colorSys.list=["#0068b1","#ff595f","#fdc559","#21ad5c","#000","#a58bba","#7a5327","#44b5e5"];
// export function drawRing(dataArray2x,optionNew) {
// 	var option={
// 		colors:stage.color.list,
// 		hover:true,
// 		lineW:8,
// 		space:[]
// 	};
// 	if(optionNew.hover==false&&!optionNew.space) option.space=[10,10,10,10];
// 	else option.space=[0,0,0,0];
// 	$.extend(option,optionNew);
// 	//处理0数据的呈现
// 	var count=0;
// 	$(dataArray2x).each(function(){
// 		count+=this[1];
// 	});
// 	if(count==0){
// 		var newData=new Array();//重新创建数据，防止改动原始数据导致后续程序使用数据有问题
// 		$(dataArray2x).each(function(index){
// 			newData.push(this.concat());
// 		});
// 		dataArray2x=newData;
// 		option.hover=false;
// 		if(optionNew.space==undefined) option.space=[10,10,10,10];
// 		dataArray2x[0][1]=1;
// 		option.colors[0]="rgba(120,120,120,.2)";
// 	}
// 	return {
// 		credits:{
// 			enabled:false	//禁用版权信息
// 		},
// 		chart:{
// 			type:'pie',
// 			backgroundColor:"transparent",
// 			spacing:option.space
// 		},
// 		title:{text:''},
// 		tooltip:{
// 			// enabled:false,
// 			pointFormat:(option.pointFormat!=undefined)?		option.pointFormat:'<b>{point.y}</b>'//{point.name}:
// 		},
// 		plotOptions:{
// 			pie:{
// 				dataLabels:{
// 					//useHTML:true,
// 					enabled:(option.dataLabelsFormat!=undefined)?	option.dataLabelsFormat:false,	//不显示图例
// 					format:(option.dataLabelsFormat!=undefined)?	option.dataLabelsFormat:'{point.name}: <b>{point.y}</b>'
// 				},
// 				//showInLegend:true,
// 				enableMouseTracking:option.hover,	//禁用交互
// 				colors:option.colors,
// 				borderWidth:0,
// 				slicedOffset:(option.hover)?	10:0,
// 				//size:($target.width()>$target.height())?$target.height():$target.width(),
// 				//innerSize:($target.width()>$target.height())?$target.height()-10*2-lineW*2:$target.width()-10*2-lineW*2
// 				innerSize:(100-option.lineW)+"%"
// 			}
// 		},
// 		series:[{
// 			data:dataArray2x
// 		}]
// 	}
// }



// WEBPACK FOOTER //
// ./src/util/chart.js